module.exports = __webpack_public_path__ + "a8a10a3e/img/menu-icon.5f8facae.svg";